module.exports = __webpack_public_path__ + "img/peakvalue.1e517308.png";